import { render, staticRenderFns } from "./FavouriteIcon.vue?vue&type=template&id=261a64d8&scoped=true&"
import script from "./FavouriteIcon.vue?vue&type=script&lang=js&"
export * from "./FavouriteIcon.vue?vue&type=script&lang=js&"
import style0 from "./FavouriteIcon.vue?vue&type=style&index=0&id=261a64d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261a64d8",
  null
  
)

export default component.exports